import { Link } from 'react-router-dom';

import  { MenuProps } from 'antd';

import CatalogIcon from 'assets/images/menu/catalog.svg?react';
import DashboardIcon from 'assets/images/menu/dashboard.svg?react';
import DocumentsIcon from 'assets/images/menu/documents.svg?react';
import EarningsIcon from 'assets/images/menu/earnings.svg?react';
import OffersIcon from 'assets/images/menu/offers.svg?react';
import HelpIcon from 'assets/images/menu/support.svg?react';
import UsersIcon from 'assets/images/menu/users.svg?react';
import { i18n } from 'i18n';
import { EMainRoutes } from 'shared/typings';

type MenuItem = Required<MenuProps>['items'][number];

// const handleLinkClick = (gaEventName: EGaEvents) => {
// 	const pathName = location.pathname.replace(/^\//, '');
// 	sendGaEvent(gaEventName, {
// 		event_option1: `${EGaCategories.ACCOUNT};${pathName || EGaTypes.DASHBOARD}`,
// 		event_option2: EGaTypes.SIDE_MENU,
// 	});
// };

export const MENU_ITEMS_PUB: MenuItem[] = [
	{
		label: <Link to={`/${EMainRoutes.PUBLISHER}/${EMainRoutes.DASHBOARD}`}>{i18n.t('Dashboard')}</Link>,
		key: EMainRoutes.DASHBOARD,
		icon: <DashboardIcon />,
		// onClick: () => handleLinkClick(EGaEvents.CLICK_DASHBOARD),
	},
	{
		label: <Link to={`/${EMainRoutes.PUBLISHER}/${EMainRoutes.TASKS}`}>{i18n.t('Tasks')}</Link>,
		key: EMainRoutes.TASKS,
		icon: <OffersIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.PUBLISHER}/${EMainRoutes.CLIENTS}`}>{i18n.t('Clients')}</Link>,
		key: EMainRoutes.CLIENTS,
		icon: <UsersIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.PUBLISHER}/${EMainRoutes.EARNINGS}`}>{i18n.t('Earnings')}</Link>,
		key: EMainRoutes.EARNINGS,
		icon: <EarningsIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.PUBLISHER}/${EMainRoutes.DOCUMENTS}`}>{i18n.t('Documents')}</Link>,
		key: EMainRoutes.DOCUMENTS,
		icon: <DocumentsIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.CATALOG}`}>{i18n.t('Catalog')}</Link>,
		key: EMainRoutes.CATALOG,
		icon: <CatalogIcon />,
		disabled: true,
		// onClick: () => handleLinkClick(EGaEvents.CLICK_CATALOG),
	},
	{
		type: 'divider',
	},
	{
		key: `menuItem_key_Help`,
		icon: <HelpIcon />,
		label: <span>{i18n.t('Help center')}</span>,
		// onClick: () => handleLinkClick(EGaEvents.CLICK_HELP_CENTER),
	},
];
